import type { World } from '@ecs/world';
import type { PlayerHealth, TimeScaleResource } from '@game/scenes/characterPrototype/types';

export type DamageAndGameOverKeys = {
	healthKey: string;
	gameOverKey: string;
	gameOverReasonKey: string;
};

export function applyPlayerDamage(
	world: World,
	keys: DamageAndGameOverKeys,
	amount: number,
	deathReason: 'dead' | 'fell' = 'dead'
) {
	const health = world.getResource<PlayerHealth>(keys.healthKey);
	if (!health) return;
	health.current = Math.max(0, health.current - amount);
	if (health.current <= 0) {
		world.setResource<'fell' | 'dead'>(keys.gameOverReasonKey, deathReason);
		world.setResource<boolean>(keys.gameOverKey, true);
	}
}

export function applyTimeBoost(world: World, timescaleKey: string, value: number, duration: number) {
	const timescale = world.getResource<TimeScaleResource>(timescaleKey);
	if (!timescale) return;
	timescale.boostValue = Math.max(timescale.boostValue, value);
	timescale.boostRemaining = Math.max(timescale.boostRemaining, duration);
}


